import React from 'react';
import { ArrowLeft, FileSliders, Settings2, Target } from 'lucide-react';
import { Dataset } from '../../types';

interface DocumentsSidebarProps {
  dataset: Dataset | any;
  activeTab: 'documents' | 'retrieval' | 'settings';
  onTabChange: (tab: 'documents' | 'retrieval' | 'settings') => void;
  onBackClick: () => void;
}

const DocumentsSidebar: React.FC<DocumentsSidebarProps> = ({
  dataset,
  activeTab,
  onTabChange,
  onBackClick
}) => {
  return (
    <div className="w-full lg:w-64 bg-white border-r border-gray-200 flex flex-col">
      {/* Header */}
      <div className="p-3 sm:p-4 border-b border-gray-200">
        <button
          onClick={onBackClick}
          className="flex items-center text-sm text-gray-600 hover:text-gray-900 mb-3"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </button>

        <div className="flex items-center space-x-2 sm:space-x-3">
          <div className="w-6 h-6 sm:w-8 sm:h-8 bg-blue-100 rounded flex items-center justify-center">
            <FileSliders className="w-3 h-3 sm:w-4 sm:h-4 text-blue-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="text-sm sm:text-base font-medium truncate text-gray-900">
              {dataset?.name || 'Knowledge Base'}
            </h1>
            <p className="text-xs text-gray-500">
              {dataset?.documents?.length || 0} document{dataset?.documents !== 1 ? 's' : ''}
            </p>
          </div>
        </div>
      </div>

      {/* LOCAL DOCS Section */}
      {/* <div className="p-4 border-b border-gray-200">
        <div className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
          LOCAL DOCS
        </div>
        <div className="text-xs text-gray-600 leading-relaxed">
          {dataset?.description}
        </div>
      </div> */}

      {/* NO LINKED APPS Section */}
      {/* <div className="p-4 border-b border-gray-200">
        <div className="flex items-center space-x-2 mb-2">
          <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
            NO LINKED APPS
          </div>
          <div className="w-4 h-4 rounded-full bg-gray-200 flex items-center justify-center">
            <span className="text-xs text-gray-500">?</span>
          </div>
        </div>
      </div> */}

      {/* Navigation */}
      <nav className="flex-1 p-3 sm:p-4">
        <div className="space-y-1">
          <button
            onClick={() => onTabChange('documents')}
            className={`w-full flex items-center space-x-2 sm:space-x-3 px-2 py-2 sm:px-3 sm:py-2 text-sm rounded-lg transition-colors ${activeTab === 'documents'
              ? 'bg-blue-50 text-blue-700'
              : 'text-gray-700 hover:bg-gray-100'
              }`}
          >
            <FileSliders className="w-4 h-4" />
            <span>Documents</span>
          </button>

          <button
            onClick={() => onTabChange('retrieval')}
            className={`w-full flex items-center space-x-2 sm:space-x-3 px-2 py-2 sm:px-3 sm:py-2 text-sm rounded-lg transition-colors ${activeTab === 'retrieval'
              ? 'bg-blue-50 text-blue-700'
              : 'text-gray-700 hover:bg-gray-100'
              }`}
          >
            <Target className="w-4 h-4" />
            <span>Retrieval Testing</span>
          </button>

          <button
            onClick={() => onTabChange('settings')}
            className={`w-full flex items-center space-x-2 sm:space-x-3 px-2 py-2 sm:px-3 sm:py-2 text-sm rounded-lg transition-colors ${activeTab === 'settings'
              ? 'bg-blue-50 text-blue-700'
              : 'text-gray-700 hover:bg-gray-100'
              }`}
          >
            <Settings2 className="w-4 h-4" />
            <span>Settings</span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default DocumentsSidebar;
